import { Box, Button, Flex, GmgTheme } from '@gmg/gmg-react-components';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import PictoInviteErrorDark from '../../../assets/svg/graphic_invite-error-dark-255.svg';
import PictoInviteErrorLight from '../../../assets/svg/graphic_invite-error-light-255.svg';


const WrongEmail: FunctionComponent<{ signOut: () => void }> = ({ signOut }) => {
    const { t } = useTranslation();
    const theme: GmgTheme = useTheme();

    return (
        <Flex height="100%" bg="backgroundPaper" justifyContent="center">
            <Div>
                {theme.type === 'dark'
                    ? <PictoInviteErrorDark width={255} height={255} />
                    : <PictoInviteErrorLight width={255} height={255} />
                }
                <h1>{t('ErrorMsg.wrongEmail', 'The invitation to the organization is bound to a different email address!')}</h1>
                <Box className="px14_400_contrast" pt="24px">
                    {t('ErrorMsg.wrongEmail_with_logout', 'Please logout and sign up again with the email address you have been invited.')}
                    <Flex justifyContent={'center'} style={{ paddingTop: '1.5rem' }}>
                        <Button
                            variant={'primary'}
                            size={'big'}
                            onClick={signOut}
                        >{t('JoinOrganization.logout_btn', 'Logout')}</Button>
                    </Flex>
                </Box>
            </Div>
        </Flex>
    );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 480px;
  text-align: center;
  line-height: 1.4;
`;

export default WrongEmail;